import * as ACTIONS from '../actions/tooltip';

export const setUniqueTooltip = (toolTipData) => ({ type: ACTIONS.SET_TOOLTIP_DATA, toolTipData });

export const setToolTip = (options) => (dispatch, getState) => {
  return dispatch(setUniqueTooltip(options));
};

export const cleanToolTipData = () => {
  const getTooltip= {};
  return ({type: ACTIONS.CLEAN_TOOLTIP_DATA, getTooltip})
}